var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZipCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1053_4903)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1053_4903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 1.11719C5.51979 1.11719 4.05078 2.5862 4.05078 4.39844C4.05078 5.86354 6.19531 8.53385 7.01693 9.50312C7.18333 9.69948 7.48099 9.69948 7.64714 9.50312C8.46875 8.53385 10.6133 5.86354 10.6133 4.39844C10.6133 2.5862 9.14427 1.11719 7.33203 1.11719ZM7.33203 5.49219C6.72786 5.49219 6.23828 5.0026 6.23828 4.39844C6.23828 3.79427 6.72786 3.30469 7.33203 3.30469C7.9362 3.30469 8.42578 3.79427 8.42578 4.39844C8.42578 5.0026 7.9362 5.49219 7.33203 5.49219ZM0.35599 6.74088C0.201348 6.80274 0.068784 6.9095 -0.0246069 7.0474C-0.117998 7.18531 -0.167932 7.34803 -0.167969 7.51458L-0.167969 14.0333C-0.167969 14.3281 0.129687 14.5297 0.403385 14.4203L3.9987 12.7839V6.71406C3.76849 6.29792 3.58021 5.89271 3.44531 5.50521L0.35599 6.74088ZM7.33203 10.4836C6.96562 10.4836 6.61901 10.3227 6.38125 10.0419C5.86927 9.43776 5.32474 8.74974 4.83203 8.04401V12.7836L9.83203 14.4503V8.04427C9.33932 8.74974 8.79505 9.43802 8.28281 10.0422C8.04505 10.3227 7.69844 10.4836 7.33203 10.4836ZM14.2607 5.31406L10.6654 6.95052V14.4505L14.3081 12.9935C14.4627 12.9317 14.5953 12.8249 14.6887 12.687C14.7821 12.5491 14.832 12.3864 14.832 12.2198V5.70104C14.832 5.40625 14.5344 5.20469 14.2607 5.31406Z",
    fill: "#808282"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1053_4903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1053_4903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(-0.167969 0.285156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCode);
export default __webpack_public_path__ + "static/media/ZipCode.d1cca9eb2e6eedf62011376bab763bea.svg";
export { ForwardRef as ReactComponent };